import React, { useState, createContext, useRef } from "react";
import { getTreeNodeData } from 'components/medialibrarymain/mediaLibrary.service';
import {prepareKey} from './tree.constant';

// Create Context Object
export const TreeCacheContext = createContext();

// Create a provider for components to consume and subscribe to changes
export const TreeCacheProvider = props => {
    const [rootCache, setrootCache] = useState({});
    const reqQueue = useRef([])    

    function setRootCacheWithKeys(key, value, customProps) {
        if (!reqQueue.current.includes(key)) {
            reqQueue.current.push(key);
        }
        setrootCache((prevValue) => {
            let newVal = { ...prevValue };
            newVal[prepareKey(key, customProps)] = value
            return newVal;
        });
    }

    function updateModel(initialNode, customProps) {
        if (reqQueue.current.includes(initialNode)) {
            return new Promise((res, rej) => res());
        } else {
            reqQueue.current.push(initialNode);
            return getTreeNodeData(initialNode === -1 ? undefined : initialNode, customProps).then((data) => {
                setRootCacheWithKeys(initialNode, data, customProps);
                
            });
        }
    }

    return (
        <TreeCacheContext.Provider value={{ rootCache, setRootCacheWithKeys, updateModel }}>
            {props.children}
        </TreeCacheContext.Provider>
    );
};